/**
 * @generated SignedSource<<339eec75f348e2a32fda637fa1a0b690>>
 * @relayHash 0913aa0e7f577fc63dfd041de0b5136e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468

import type { ConcreteRequest } from 'relay-runtime';
export type StarredContentMenuQuery$variables = {
  limit?: number | null | undefined;
  start: number;
};
export type StarredContentMenuQuery$data = {
  readonly favoriteContent: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly nodes: ReadonlyArray<{
      readonly emoji: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id: string | null | undefined;
      readonly links: {
        readonly editui: string | null | undefined;
        readonly webui: string | null | undefined;
      } | null | undefined;
      readonly metadata: {
        readonly currentuser: {
          readonly favourited: {
            readonly favouritedDate: string | null | undefined;
            readonly isFavourite: boolean | null | undefined;
          } | null | undefined;
          readonly lastcontributed: {
            readonly status: string | null | undefined;
            readonly when: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
      };
      readonly space: {
        readonly id: string | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly status: string | null | undefined;
      readonly subType: string | null | undefined;
      readonly title: string | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type StarredContentMenuQuery = {
  response: StarredContentMenuQuery$data;
  variables: StarredContentMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "status"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
      },
      {
        "kind": "Variable",
        "name": "start",
        "variableName": "start"
      }
    ],
    "concreteType": "PaginatedContentList",
    "kind": "LinkedField",
    "name": "favoriteContent",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "kind": "ScalarField",
            "name": "subType"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          (v2/*: any*/),
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              }
            ]
          },
          {
            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "webui"
              },
              {
                "kind": "ScalarField",
                "name": "editui"
              }
            ]
          },
          {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "FavouritedSummary",
                    "kind": "LinkedField",
                    "name": "favourited",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "favouritedDate"
                      }
                    ]
                  },
                  {
                    "concreteType": "ContributionStatusSummary",
                    "kind": "LinkedField",
                    "name": "lastcontributed",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "when"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "emoji",
            "args": [
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "emoji-title-published",
                  "emoji-title-draft"
                ]
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ],
            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          }
        ]
      },
      {
        "concreteType": "ContentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "cursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StarredContentMenuQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StarredContentMenuQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0913aa0e7f577fc63dfd041de0b5136e",
    "id": "ae0bd328ec8252dd2e2f88475c08a5447b0ace0d9051443e47deaca0e2dcd468",
    "metadata": {},
    "name": "StarredContentMenuQuery",
    "operationKind": "query",
    "text": "query StarredContentMenuQuery($limit:Int=30,$start:Int!){favoriteContent(limit:$limit,start:$start){nodes{id,type,subType,title,status,space{id,name},links{webui,editui},metadata{currentuser{favourited{isFavourite,favouritedDate},lastcontributed{status,when}}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}}},pageInfo{hasNextPage},edges{cursor}}}"
  }
};
})();

(node as any).hash = "d919f41ac18e2cfc51a95f7043552fc1";

export default node;
